import { SimpleModal } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from 'src/components/transactions/RefundModal/styles';
import { useStore } from 'src/stores';
const CheckModal = _ref => {
  let handleClose = _ref.handleClose,
    isOpen = _ref.isOpen,
    setChecked = _ref.setChecked;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: t('resident_account.post_payment')
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('resident_account.post_payment_info_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    'custom-attribute': '454-check-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.transaction.voidTransactionAsync.inProgress,
    onClick: () => setChecked(true),
    variant: "contained",
    'custom-attribute': '455-check-modal'
  }, t('resident_account.yes')))))));
};
export default CheckModal;